class ObjectValidator {
  isEmpty(object) {
    return Object.keys(object).length === 0;
  }
}
const objectValidator = new ObjectValidator();
export default objectValidator;